var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 54,
    viewBox: "0 0 56 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5986 1L19.3867 17.8401L1.01953 20.5365L14.3115 33.6436L11.1701 52.1531L27.5986 43.4167L44.0319 52.1531L40.8905 33.6436L54.1825 20.5365L35.8153 17.8401L27.5986 1Z",
    fill: "#FED001"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.48107 21.0184L1 20.5317L19.3672 17.8353L26.8575 2.52344C25.9723 8.21307 24.5291 17.3291 23.971 20.2494C23.2494 24.0262 9.25996 22.6245 1.48107 21.0184Z",
    fill: "#FFE636"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7723 23.9045C47.3519 25.5788 43.3735 27.7301 40.718 29.8083C35.1905 34.1303 40.718 47.3298 40.718 47.3298C40.718 47.3298 33.0209 40.5451 28.417 39.8394C23.8132 39.1337 14.8317 48.2254 14.8317 48.2254C14.8317 48.2254 16.3615 35.2935 15.6687 33.0401C15.3368 31.979 12.0559 29.9446 8.68359 28.0951L14.3121 33.6728L11.1852 52.1677L27.5992 43.407L44.0325 52.1677L40.8912 33.6728L50.7723 23.9045Z",
    fill: "#E2B901"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3594 50.4886L27.599 42.1999L41.9349 49.705L39.568 33.0401L46.8322 27.3456L40.891 33.6436L43.633 51.7784L27.599 43.2026L13.3594 50.4886Z",
    fill: "#B99701"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5488 7.40027L20.1801 18.4729L6.00781 20.5268L20.8103 19.6848L25.5488 7.40027Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5986 1L19.3867 17.8401L1.01953 20.5365L14.3115 33.6436L11.1701 52.1531L27.5986 43.4167L44.0319 52.1531L40.8905 33.6436L54.1825 20.5365L35.8153 17.8401L27.5986 1Z",
    stroke: "#C27701",
    strokeWidth: 1.73,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.2322ccb979d2f2a73c7a4f1199f52a87.svg";
export { ForwardRef as ReactComponent };